<div class="info-card-container overflow-auto">
  <div class="info-card border-1 border-neutral-base-primary-border border-round-lg overflow-hidden bg-white">
    @for (item of data(); track $index) {
      <div class="item flex align-items-stretch">
        <div class="item-name col-5 xl:col-4 py-spacing-md px-spacing-3xl text-caption-color">
          <span>{{ item.name | keyDisplayName }}</span>
        </div>
        <div class="item-value col-7 xl:col-8 py-spacing-md px-spacing-3xl text-secondary-color">
          @if (item.isTag) {
            <app-tag
              styleClass="bold"
              [content]="item.value.toString()"
              sizeClass="tag-sm"
              [severityClass]="item.tagSeverity || 'info'"></app-tag>
          } @else {
            @if (item.type == tableColumnsDataType.date) {
              <span>{{ item.value | date: "MM/dd/yyyy" }}</span>
            } @else if (item.name == "Sign In Status") {
              <span class="capitalize">{{ item.value.status }}</span>
              <span class="form-placeholder-color">{{ item.value.date }}</span>
            } @else {
              <span [ngClass]="{ capitalize: item.name != 'Account Number' && item.name != 'Routing Number' }">
                {{ item.value }}
              </span>
            }
          }
        </div>
      </div>
    }
  </div>
</div>
